import React, { useLayoutEffect } from 'react'
import { injectIntl } from 'gatsby-plugin-intl'

import { Highlights, HomeOutdoor } from '../components'
import { onViewportEnter } from '../utils'

import "./index.scss"

const IndexPage = ( { intl } ) => {
  useLayoutEffect( onViewportEnter )

  return (
    <>
      <HomeOutdoor />
      <Highlights />
    </>
  )
}

export default injectIntl( IndexPage )
